/* eslint-disable */
import { DocumentDatabaseSystem } from '../dto/document-database-system';
import { ServiceAgentDownloadCategory } from '../dto/service-agent-download-category';

export interface ServiceAgentDownloadListDto {
  id: number;
  title: string;
  version?: string | null;
  dateValidFrom: Date;
  databaseSystem?: DocumentDatabaseSystem | null;
  productShorthand: string[];
  category: ServiceAgentDownloadCategory;
}

export const fixServiceAgentDownloadListDtoFromJson = (dto?: ServiceAgentDownloadListDto | null): void => {
  if (!dto) {
    return;
  }
  dto.dateValidFrom = dto.dateValidFrom && new Date(dto.dateValidFrom);
};

export const fixServiceAgentDownloadListDtoToJson = (dto?: ServiceAgentDownloadListDto | null): void => {
  if (!dto) {
    return;
  }
};
